<template>
  <v-dialog
    v-model="$root.alertDialog"
    max-width="350px"
    @click:outside="$root.alertDialog = false"
  >
    <v-card>
      <v-card-title>{{ $root.alertTitle }}</v-card-title>
      <v-card-text v-html="$root.alertMessage"></v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="green" @click="$root.alertDialog = false">
          Okay
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    templates() {
      return this.$store.getters.templates;
    },
  },
};
</script>

<style></style>
